import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthServiceBase } from '../services/auth/auth.service.base';
import { UserAccessStore } from '../services/user-access/user-access.store';
import { RegisteredApplicationStore } from '../services/registered-applications/registered-application.store';

export const supportEntryGuard: CanActivateFn = () => {
  const auth = inject(AuthServiceBase);
  const store = inject(UserAccessStore);
  const reg = inject(RegisteredApplicationStore);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.parseUrl('/');
  }

  return store.load().pipe(
    map((access) => {
      store.reconcilePreferredEntryWithAccess(access);
      if (access.isSupport) {
        store.setPreferredEntry('support');
        reg.clear();
      }
      return router.parseUrl('/registered-applications');
    }),
    catchError(() => of(router.parseUrl('/registered-applications')))
  );
};
